import { Alert, Stack } from "@mui/material";
import { useToastStore } from "../../store/toastStore";
import styles from "./toaster.module.css";

// App-wide toast stack. Mounted once at the app root; surfaces feed it through
// the toastStore helpers (toastSuccess / toastApiError / …).
export const Toaster = () => {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <Stack className={styles.stack} spacing={1} role="status" aria-live="polite">
      {toasts.map((toast) => (
        <Alert
          key={toast.id}
          severity={toast.severity}
          variant="filled"
          onClose={() => dismiss(toast.id)}
          className={styles.alert}
        >
          {toast.message}
        </Alert>
      ))}
    </Stack>
  );
};
